.panel {
  display: flex;
  align-items: end;
  gap: var(--space-4);
}

.language {
  display: grid;
  gap: var(--space-1);
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
  font-weight: 700;
}

.language select {
  min-height: 2.75rem;
  padding: 0 var(--space-8) 0 var(--space-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-small);
  color: var(--color-text);
  background: var(--color-surface);
  font: inherit;
  cursor: pointer;
}

.theme {
  min-inline-size: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.theme legend {
  margin-block-end: var(--space-1);
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
  font-weight: 700;
}

.themeOptions {
  display: flex;
  padding: 0.1875rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-small);
  background: var(--color-surface);
}

.themeOptions label {
  position: relative;
  cursor: pointer;
}

.themeOptions input {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.themeOptions span {
  display: grid;
  min-block-size: 2.25rem;
  padding-inline: var(--space-3);
  place-items: center;
  border-radius: calc(var(--radius-small) - 0.1875rem);
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
  font-weight: 700;
}

.themeOptions input:checked + span {
  color: var(--color-on-accent);
  background: var(--color-accent);
}

.themeOptions input:focus-visible + span {
  outline: var(--focus-width) solid var(--color-focus);
  outline-offset: var(--focus-offset);
}

@media (max-width: 43rem) {
  .panel {
    inline-size: 100%;
    align-items: stretch;
    justify-content: space-between;
  }

  .language,
  .theme {
    flex: 1;
  }

  .language select,
  .themeOptions {
    inline-size: 100%;
  }

  .themeOptions label {
    flex: 1;
  }
}
